export class EthnicityReducerState {
  americanIndianOrAlaskaNative?: boolean;
  asian?: boolean;
  blackOrAfricanAmerican?: boolean;
  hispanicOrLatin?: boolean;
  nativeHawaiianOrOtherPacificIslander?: boolean;
  white?: boolean;
  mixedRace?: boolean;
  other?: boolean;

  constructor(
    americanIndianOrAlaskaNative?: boolean,
    asian?: boolean,
    blackOrAfricanAmerican?: boolean,
    hispanicOrLatin?: boolean,
    nativeHawaiianOrOtherPacificIslander?: boolean,
    white?: boolean,
    mixedRace?: boolean,
    other?: boolean
  ) {
    this.americanIndianOrAlaskaNative = americanIndianOrAlaskaNative || false;
    this.asian = asian || false;
    this.blackOrAfricanAmerican = blackOrAfricanAmerican || false;
    this.hispanicOrLatin = hispanicOrLatin || false;
    this.nativeHawaiianOrOtherPacificIslander =
      nativeHawaiianOrOtherPacificIslander || false;
    this.white = white || false;
    this.mixedRace = mixedRace || false;
    this.other = other || false;
  }
}
